import React from 'react'
import { ICellRendererParams } from 'ag-grid-community'
import { isNil } from 'lodash-es'
import { NegotiationDetailWithMeta } from 'api'

export interface NegotiationCellRendererProps extends ICellRendererParams {
  selectedNegotiationDetail?: NegotiationDetailWithMeta
}

export function createCounterpartyCellRenderer<P extends NegotiationCellRendererProps>(Component: React.ComponentType<P>) {
  return class CellRenderer extends React.Component<P> {
    render() {
      const {
        props: { node, selectedNegotiationDetail }
      } = this

      const isGroupRow = !!node.group

      if (isGroupRow || isNil(selectedNegotiationDetail)) {
        return null
      }

      return <Component {...this.props} data={selectedNegotiationDetail} node={{ ...node, data: selectedNegotiationDetail }} />
    }

    refresh = () => {
      this.forceUpdate()
      return true
    }
  }
}
